import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/:who?',
    name: 'Home',
    component: () => import('../views/Home.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
